import { siteImageUrl } from "@/lib/siteAssets";

/* Neutral placeholder: cable cross-section mark on a plain background.
   Shown until the owner uploads a real photo into this slot from the admin desk. */
function CrossSectionMark({ className = "" }) {
    return (
        <svg viewBox="0 0 120 120" className={className} aria-hidden="true" fill="none">
            <circle cx="60" cy="60" r="52" stroke="currentColor" strokeWidth="3" opacity="0.45" />
            <circle cx="60" cy="60" r="42" stroke="currentColor" strokeWidth="1.5" opacity="0.25" />
            {[0, 60, 120, 180, 240, 300].map((deg) => {
                const rad = (deg * Math.PI) / 180;
                const x = 60 + 24 * Math.cos(rad);
                const y = 60 + 24 * Math.sin(rad);
                return <circle key={deg} cx={x} cy={y} r="10" stroke="currentColor" strokeWidth="2.5" opacity="0.55" />;
            })}
            <circle cx="60" cy="60" r="10" stroke="currentColor" strokeWidth="2.5" opacity="0.55" />
        </svg>
    );
}

export default function CableImage({ slot, images, alt, className = "", label = "" }) {
    const has = images && images[slot];
    if (has) {
        return (
            <img
                src={siteImageUrl(slot)}
                alt={alt || "Product photo"}
                className={className}
                loading="lazy"
                data-testid={`site-image-${slot}`}
            />
        );
    }
    return (
        <div
            className={`${className} flex flex-col items-center justify-center bg-paper2 text-dim gap-2`}
            data-testid={`site-image-placeholder-${slot}`}
            role="img"
            aria-label={alt || "Photo coming soon"}
        >
            <CrossSectionMark className="w-16 h-16" />
            {label && (
                <span className="font-mono text-[9px] uppercase tracking-[0.2em] opacity-70 px-3 text-center">
                    {label}
                </span>
            )}
        </div>
    );
}
